import React, { useState } from "react";
import { pdf } from "@react-pdf/renderer";
import { InvoiceDocument } from "../pages/reciept";
import { toast } from "react-toastify";

export default function BulkReceiptDownloader({ receipts = [] }) {
  const [downloading, setDownloading] = useState(false);
  const downloadAllReceipts = async () => {
    if (downloading || !receipts.length) return;
    setDownloading(true);
    try {
      const groups = new Map();
      receipts.forEach(receipt => {
        const key = receipt.ppTransectionId || receipt.orderId || receipt.transactionId;
        if (!groups.has(key)) groups.set(key, []);
        groups.get(key).push(receipt);
      });
      for (const group of groups.values()) {
        const details = group[0];
        const receipt = {
          ...details,
          transacId: details.transactionId,
          tokenPrice: ((Number(details.itemAmount) * group.length * 82) / 100).toFixed(2),
          gstAmount: ((Number(details.itemAmount) * group.length * 18) / 100).toFixed(2),
          quantity: group.length,
          totAmt: details.amount,
        };
        const blob = await pdf(<InvoiceDocument indTrascDetails={receipt} />).toBlob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `invoice_${details.orderId || details.transactionId}.pdf`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(() => URL.revokeObjectURL(url), 1000);
      }
    } catch (error) {
      toast.error(error.message || "Unable to download receipts.");
    } finally {
      setDownloading(false);
    }
  };
  return <button type="button" disabled={downloading || !receipts.length} onClick={downloadAllReceipts}>
    {downloading ? "Downloading receipts..." : "Download All Receipts"}
  </button>;
}
